import React from "react";
import { useApp } from "../context/AppContext";
import { User, GraduationCap, ShieldCheck, Target, Eye } from "lucide-react";

const About = () => {
  const { t } = useApp();

  const forWho = [
    { icon: User, title: t.about.f1t, desc: t.about.f1d },
    { icon: GraduationCap, title: t.about.f2t, desc: t.about.f2d },
    { icon: ShieldCheck, title: t.about.f3t, desc: t.about.f3d },
  ];

  return (
    <div className="pt-16 min-h-screen">
      <section className="relative overflow-hidden border-b border-white/5">
        <div className="absolute inset-0 hero-glow" />
        <div className="relative max-w-3xl mx-auto px-5 py-24 text-center">
          <h1 className="font-display text-4xl sm:text-5xl font-bold text-white">{t.about.title}</h1>
          <p className="text-gray-400 mt-5 text-lg leading-relaxed">{t.about.lead}</p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-5 py-20 grid md:grid-cols-2 gap-6">
        <div className="bg-[#0f1116] border border-white/8 rounded-2xl p-8">
          <div className="w-11 h-11 rounded-xl bg-blue-500/10 border border-blue-500/20 flex items-center justify-center mb-5">
            <Target className="w-5 h-5 text-blue-400" />
          </div>
          <h2 className="font-display text-2xl font-bold text-white">{t.about.mTitle}</h2>
          <p className="text-gray-400 mt-3 leading-relaxed">{t.about.mText}</p>
        </div>
        <div className="bg-[#0f1116] border border-white/8 rounded-2xl p-8">
          <div className="w-11 h-11 rounded-xl bg-orange-500/10 border border-orange-500/20 flex items-center justify-center mb-5">
            <Eye className="w-5 h-5 text-orange-400" />
          </div>
          <h2 className="font-display text-2xl font-bold text-white">{t.about.vTitle}</h2>
          <p className="text-gray-400 mt-3 leading-relaxed">{t.about.vText}</p>
        </div>
      </section>

      <section className="bg-[#0a0c10] border-y border-white/5">
        <div className="max-w-6xl mx-auto px-5 py-20">
          <div className="grid md:grid-cols-3 gap-6">
            {forWho.map((f, i) => (
              <div key={i} className="card-hover bg-[#0f1116] border border-white/8 rounded-2xl p-7">
                <div className="w-12 h-12 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center mb-5">
                  <f.icon className="w-6 h-6 text-blue-400" />
                </div>
                <h3 className="font-semibold text-white text-lg">{f.title}</h3>
                <p className="text-sm text-gray-400 mt-2 leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
